export default __webpack_public_path__ + "static/bg-finance--mobile-c6bfca1a136c8f0f7293e2d709e06fc3.jpg";